export default async ({ commit, rootGetters}) => {
    let dateInfo = await rootGetters['date/dayInfo']

    if(dateInfo) {

        let checkDate = false

        if(dateInfo.holiday) {

            checkDate = true

            let holidayCoef = await rootGetters['settings/priceHolidays']

            commit('setDatePrice', {
                type: 'holiday',
                value: holidayCoef
            })

        }

        if(dateInfo.weekend) {

            checkDate = true

            let weekendCoef = await rootGetters['settings/priceWeekend']

            commit('setDatePrice', {
                type: 'holiday',
                value: weekendCoef
            })

        }

        if(!checkDate) {
            commit('setDatePrice', {
                type: 'default',
                value: 1
            })
        }

    }
}